import styled from 'styled-components'

export const SessionList = styled.div``
